import {
    BloombergMarketDataRequest,
    requestUid,
} from 'marketData/MarketDataRequest';
import { SidecarApi } from '@instinet-bcng/sidecar-client';
import { ActionsDispatcher } from 'store/ActionsDispatcher';
import { AnyAction as AnyReduxAction } from 'redux';

type RequestManagerStatus = 'Not Started' | 'Running' | 'Error' | 'Complete';

export abstract class SidecarRequestManager<
    TRequest extends BloombergMarketDataRequest,
> {
    public readonly request: TRequest;
    public status: RequestManagerStatus = 'Not Started';

    protected readonly api: SidecarApi;
    protected readonly dispatcher: ActionsDispatcher;

    protected constructor(options: {
        api: SidecarApi;
        request: TRequest;
        dispatcher: ActionsDispatcher;
    }) {
        this.request = options.request;
        this.api = options.api;
        this.dispatcher = options.dispatcher;
    }

    public get uid(): string {
        return requestUid(this.request);
    }

    public abstract subscribe(): Promise<void>;

    public abstract unsubscribe(): Promise<void>;

    protected dispatch(...actions: AnyReduxAction[]) {
        this.dispatcher.dispatch(...actions);
    }
}
